module.exports = __webpack_public_path__ + "img/lacoste_content_img_04.b851bc95.jpg";